import type { ReactNode } from 'react'
import { SplitText } from '@/components/motion/SplitText'
import { SectionIndex } from '@/components/ui/SectionIndex'

interface SectionHeadingProps {
  title: string
  id?: string
  lede?: string
  level?: 2 | 3
  index?: string
  children?: ReactNode
}

export function SectionHeading({
  title,
  id,
  lede,
  level = 2,
  index,
  children,
}: SectionHeadingProps) {
  const Tag = level === 2 ? 'h2' : 'h3'

  return (
    <div className="section-heading" data-index={index}>
      {index === undefined ? null : <SectionIndex value={index} />}
      <Tag className="section-heading__title" id={id}>
        <SplitText text={title} stagger={34} />
      </Tag>
      {lede === undefined ? null : <p className="section-heading__lede">{lede}</p>}
      {children}
    </div>
  )
}
